<div class="page-heading">
  <div class="mobile-heading">
    <h3 class="fw-bold mb-0">{{ companyName }}</h3>
  </div>
  <div class="top-nav">
    <div class="desktop-heading">
      <h3 class="fw-bold">{{ companyName }}</h3>
    </div>
    <div></div>
    <div class="top-nav-menu-item-container">
      <div class="top-nav-menu-item">
        <i class="fas fa-check-circle"></i>
        <span (click)="selectCompany()">Select</span>
      </div>
      <div class="top-nav-menu-item">
        <i class="fas fa-sign-out-alt"></i>
        <span (click)="logout()">Logout</span>
      </div>
    </div>
  </div>
</div>

<div class="form-page">
  <div class="form-page-layout">
    <div class="form-page-visual" aria-hidden="true">
      <img src="assets/images/subscriber-login/login-panel.svg" alt="" width="681" height="688" />
    </div>

    <div class="form-page-panel">
      @if (loginForm) {
        <form class="login-form figma-auth-form" [formGroup]="loginForm" (ngSubmit)="Userlogin()">
          <div class="login-form-content">
            <div class="login-logo">
              <img src="assets/images/login-logo.svg" alt="A Square Logo" width="185" height="38" />
            </div>

            <div class="login-heading">
            <h3>Welcome back.</h3>
            <p>Let's simplify your business today.</p>
          </div>

          <div class="login-fields-block">
            <div class="login-fields-cluster">
              <div class="login-input-stack">
                <div class="field-item">
                  <label for="login-username">Username*</label>
                  <div class="figma-input">
                    <span class="figma-input__leading-icon" aria-hidden="true">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.99967" cy="4.00004" r="2.66667" stroke="currentColor" stroke-width="1.3" />
                        <path d="M13.3337 11.6666C13.3337 13.3235 13.3337 14.6666 8.00033 14.6666C2.66699 14.6666 2.66699 13.3235 2.66699 11.6666C2.66699 10.0098 5.05481 8.66663 8.00033 8.66663C10.9458 8.66663 13.3337 10.0098 13.3337 11.6666Z" stroke="currentColor" stroke-width="1.3" />
                      </svg>
                    </span>
                    <input
                      pInputText
                      id="login-username"
                      placeholder="Enter Username"
                      formControlName="Username"
                      autocomplete="username"
                    />
                  </div>
                  @if (loginForm.get('Username')?.invalid && loginForm.get('Username')?.touched) {
                    <small class="field-error">{{ getErrorMessage() }}</small>
                  }
                </div>

                <div class="field-item">
                  <label for="login-password">Password*</label>
                  <div class="figma-input">
                    <span class="figma-input__leading-icon" aria-hidden="true">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_login_lock)">
                          <path d="M1.33301 10.6666C1.33301 8.78101 1.33301 7.8382 1.91879 7.25241C2.50458 6.66663 3.44739 6.66663 5.33301 6.66663H10.6663C12.552 6.66663 13.4948 6.66663 14.0806 7.25241C14.6663 7.8382 14.6663 8.78101 14.6663 10.6666C14.6663 12.5522 14.6663 13.4951 14.0806 14.0808C13.4948 14.6666 12.552 14.6666 10.6663 14.6666H5.33301C3.44739 14.6666 2.50458 14.6666 1.91879 14.0808C1.33301 13.4951 1.33301 12.5522 1.33301 10.6666Z" stroke="currentColor" stroke-width="1.3" />
                          <path d="M4 6.66671V5.33337C4 3.12424 5.79086 1.33337 8 1.33337C10.2091 1.33337 12 3.12424 12 5.33337V6.66671" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_login_lock">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <p-password
                      inputId="login-password"
                      formControlName="Password"
                      [toggleMask]="true"
                      [feedback]="false"
                      styleClass="figma-password"
                      inputStyleClass="figma-password-input"
                      placeholder="Enter Password"
                      autocomplete="current-password"
                    />
                  </div>
                </div>
              </div>

              @if (deleteMode === 'financialYear' || !isDelete) {
                <div class="field-item">
                  <label for="login-financial-year">Financial Year</label>
                  <div class="figma-input figma-input--select">
                    <p-select
                      inputId="login-financial-year"
                      class="figma-select"
                      formControlName="FinancialYear"
                      [options]="financialyears"
                      optionLabel="viewValue"
                      optionValue="value"
                      placeholder="Financial Year"
                      [filter]="true"
                      appendTo="body"
                    />
                  </div>
                </div>
              }

              @if (isDelete === false) {
                <div class="login-options">
                  <label class="remember-me">
                    <input type="checkbox" class="remember-me-toggle" [(ngModel)]="rememberMe" [ngModelOptions]="{ standalone: true }" />
                    <span class="remember-me-switch-wrap" aria-hidden="true">
                      <span class="remember-me-switch">
                        <svg class="remember-me-switch__svg remember-me-switch__svg--off" width="36" height="20" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path class="remember-me-switch__track" d="M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10C36 15.5228 31.5228 20 26 20H10C4.47715 20 0 15.5228 0 10Z" fill="#D5D7DA" />
                          <path class="remember-me-switch__knob" d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z" fill="white" />
                        </svg>
                        <svg class="remember-me-switch__svg remember-me-switch__svg--on" width="36" height="20" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path class="remember-me-switch__track" d="M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10C36 15.5228 31.5228 20 26 20H10C4.47715 20 0 15.5228 0 10Z" fill="#0076FE" />
                          <path class="remember-me-switch__knob" d="M19 10C19 6.13401 22.134 3 26 3C29.866 3 33 6.13401 33 10C33 13.866 29.866 17 26 17C22.134 17 19 13.866 19 10Z" fill="white" />
                        </svg>
                      </span>
                    </span>
                    <span class="remember-me-label">Remember me</span>
                  </label>
                  <a class="forgot-password-link" (click)="redirectToForgotPassword()">Forgot password?</a>
                </div>
              }
            </div>

            @if (isDelete === false) {
              <div class="login-captcha">
                <ngx-recaptcha2
                  #captchaElem
                  [siteKey]="captchaSiteKey"
                  [size]="captchaSize"
                  [hl]="captchaLang"
                  [theme]="captchaTheme"
                  [type]="captchaType"
                  formControlName="recaptcha"
                  (success)="handleCaptchaSuccess($event)"
                />
              </div>
            }

            @if (isDelete === false) {
              <button
                class="login-submit-btn"
                [class.login-submit-btn--loading]="isLoading"
                type="submit"
                [disabled]="isLoading"
                [attr.aria-busy]="isLoading"
              >
                @if (isLoading) {
                  <span class="gradient-loader" aria-hidden="true"></span>
                } @else {
                  <span class="login-submit-btn-label">Login</span>
                }
              </button>
            }

            @if (isDelete) {
              <button class="login-submit-btn login-submit-btn--danger" type="submit">Delete</button>
            }

            @if (ErrorMessage) {
              <p class="login-status-text">{{ ErrorMessage }}</p>
            }
          </div>

            @if (isDelete === false) {
              <p class="login-signup-footer">
                Not registered yet?
                <a (click)="redirectToSignup()">Create an Account</a>.
              </p>
            }
          </div>

          @if (isDelete === false) {
            <p class="login-copyright">© 2026 ASERP. All Rights Reserved.</p>
          }
        </form>
      }
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" [ngStyle]="{ display: displayConfirmDelete }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirm Delete</h4>
        <button type="button" class="btn-close" (click)="closeConfirm()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure want to Delete?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">Confirm</button>
        <button type="button" class="btn btn-outline-secondary" (click)="closeConfirm()">Cancel</button>
      </div>
    </div>
  </div>
</div>
